import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-stepper-dialog',
  templateUrl: './stepper-dialog.component.html',
  styleUrls: ['./stepper-dialog.component.scss']
})
export class StepperDialogComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: {title: string, detail:string, count:number, maxcount:number, accept:string, cancel:string}) { }

  ngOnInit(): void 
  {

  }

  countTap(amount:number)
  {
    this.data.count += amount;

    if(this.data.count < 0)
      this.data.count = 0;

    if(this.data.count > this.data.maxcount)
      this.data.count = this.data.maxcount;
  }

}
